const RESOURCE_LINKS_MAPPING = (links) => ({
  Profile: links.private_profile,
  Mission: links.mission,
  "Mission Role": (missionAndRoleId) => `/missions/${missionAndRoleId}`,
  "Mission Role Applicant": (trailingPath) => `/missions/${trailingPath}`,
  Organization: links.organization_profile,
  List: links.list,
  Squad: links.squad,
});

export default RESOURCE_LINKS_MAPPING;
